/** Match server/judge_excludes.py: trim, lowercase, and collapse whitespace. */
export function normalizePrompt(prompt: string): string {
  return prompt.trim().toLowerCase().split(/\s+/).filter(Boolean).join(" ");
}

/** SHA-256 hash used by the judge-stats exclusion API. */
export async function hashPrompt(prompt: string): Promise<string> {
  const bytes = new TextEncoder().encode(normalizePrompt(prompt));
  const digest = await crypto.subtle.digest("SHA-256", bytes);
  return Array.from(new Uint8Array(digest), (byte) => byte.toString(16).padStart(2, "0")).join("");
}
